<template>
<v-card height="100%" width="100%"
  :class="{'blue lighten-5': selected}"
  class="d-flex flex-column" >
  <v-card-title class="py-1 darken-2" >
    <v-icon v-if="role && role.icon" class="mr-2" >{{role.icon}}</v-icon>
    {{role.title}}
  </v-card-title>
  <v-divider/>
  <v-card-text class="grow" >
    {{role.description}}
  </v-card-text>
  <v-alert tile text border-left type="info"
    v-if="role.standard_price && role.price !== role.standard_price" >
    <strong >Special pricing applies</strong>:
    {{role.price_reason}}
  </v-alert>
  <v-divider/>
  <v-list>
    <v-list-item >
      <v-list-item-action >
        <strong>{{ formatCurrency(role.currency, role.price) }}</strong>
        <v-list-item-action-text v-if="role.standard_price" >
          <s>{{ formatCurrency(role.currency, role.standard_price) }}</s>
        </v-list-item-action-text>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action >
        <v-btn
          @click="setSelected"
          color="primary" >Select</v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
  <!-- <pre v-text="role" />
  <v-card-actions >
    <v-chip v-if="role.price" class="ml-2" >
      {{ formatCurrency(role.currency, role.price) }}
    </v-chip>
    <v-spacer/>
    <v-btn
      @click="setSelected"
      color="primary" >Select</v-btn>
  </v-card-actions> -->
</v-card>
</template>
<script>

export default {
  name: 'RoleCard',
  props: {
    role: { type: Object, required: true },
    initialRoleId: { required: false },
    selected: { type: Boolean, default: false }
  },
  data () {
    return {
      selectedPackage: 'pro-za'
    }
  },
  methods: {
    setSelected () {
      let data = this.role
      data.package = this.selectedPackage
      this.$emit('selected', data)
    }
  }
}
</script>
